import type { FieldKind, JsonSchemaNode, WidgetHint } from './types';

/**
 * Resolves what to render for one field. An explicit `uiSchema.widgets` hint
 * always wins — it exists specifically for the cases the schema alone can't
 * disambiguate (short text vs. long text, or a string that's really a
 * signature/photo reference — see docs/forms-schema.md's field-type table,
 * `app.mainlinepro` API repo). Everything else is inferred from the JSON
 * Schema shape itself, which IS unambiguous for the rest.
 */
export function resolveFieldKind(schema: JsonSchemaNode, hint: WidgetHint | undefined): FieldKind {
  if (hint) {
    return hint;
  }

  if (schema.type === 'object') {
    return 'section';
  }

  if (schema.type === 'array') {
    return schema.items?.type === 'object' ? 'repeatingGroup' : 'multiSelect';
  }

  if (schema.type === 'boolean') {
    return 'checkbox';
  }

  if (schema.type === 'string' && schema.format === 'date') {
    return 'date';
  }

  if (schema.type === 'string' && schema.enum) {
    return 'select';
  }

  if (schema.type === 'number' || schema.type === 'integer') {
    return 'number';
  }

  return 'text';
}
